import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  ExpiredBusinessPlans: [],
  isSuccess: false,
  message: null,
  status: "idle", // idle | loading | succeeded | failed
  error: null,
};

// ===== API CALL =====
export const fetchExpiredBusinessPlans = createAsyncThunk("/ExpiredBusinessPlan/Get", async () => {
  const response = await axiosInstanceAuth.get("/Business/getExpireBusinessSubcription");
  return response.data;
});

// ===== SLICE =====
const ExpiredBusinessPlanSlice = createSlice({
  name: "ExpiredBusinessPlan",
  initialState,
  reducers: {
    resetExpiredBusinessPlanState: state => {
      state.ExpiredBusinessPlans = [];
      state.isSuccess = false;
      state.message = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(revertAll, () => initialState)

      // ===== FETCH =====
      .addCase(fetchExpiredBusinessPlans.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchExpiredBusinessPlans.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.isSuccess = action.payload?.IsSuccess;
        state.message = action.payload?.Message;
        state.ExpiredBusinessPlans = action.payload?.Data || [];
      })
      .addCase(fetchExpiredBusinessPlans.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// ===== SELECTOR =====
export const getExpiredBusinessPlanDetails = state => state.ExpiredBusinessPlan;

// ===== EXPORTS =====
export const { resetExpiredBusinessPlanState } = ExpiredBusinessPlanSlice.actions;

export default ExpiredBusinessPlanSlice.reducer;
